import React from "react";

export default function OpenBook(props) {
  return (
    <svg
      focusable="false"
      aria-hidden={true}
      width={85}
      height={59}
      viewBox="0 0 85 59"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M78.147 46.451c-4.403-1.124-12.477-2.718-18.414-1.227-4.944 1.245-10.373 3.316-14.121 4.867V13.583c2.607-1.635 8.755-5.196 15.253-6.83 5.397-1.36 14.531.33 17.282 1.628v38.07zm-58.761-1.834c-4.746 0-9.722 1.036-12.848 1.834V8.381c2.753-1.298 11.885-2.989 17.284-1.628 6.498 1.634 12.645 5.196 15.251 6.832v36.506c-3.747-1.55-9.175-3.622-14.12-4.867-1.723-.434-3.625-.607-5.567-.607zM82.721 3.765C78.841.903 66.507-1.137 59.203.701 52.03 2.506 45.463 6.212 42.342 8.15c-3.12-1.937-9.685-5.643-16.857-7.448C18.184-1.137 5.842.903 1.963 3.765.34 4.963 0 6.305 0 7.22v41.746c0 2.043 1.478 3.84 3.595 4.371l.951.236.93-.302c3.121-1.015 12.412-3.355 17.815-1.997 7.844 1.975 17.503 6.427 17.6 6.471l.73.312h1.5l.674-.312c.097-.044 9.743-4.492 17.6-6.47 5.379-1.356 14.688.984 17.817 1.996l.93.302.948-.236c2.117-.532 3.595-2.328 3.595-4.37V7.22c0-.915-.341-2.257-1.964-3.455z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
